<div class="menu-above">
  <div class="menu-above-left" [class.mobile]="(screenSize$ | async)?.isMobile">
    <img
      *ngIf="routing.theme !== 'light'"
      class="navlogo pendo-nav-logo"
      src="assets/logo/{{ logo }}_menu.svg"
      alt="yukkalab"
      (click)="inLogo()"
    />
    <img
      *ngIf="routing.theme === 'light'"
      class="navlogo pendo-nav-logo"
      src="assets/logo/{{ logo }}_menu_light.svg"
      alt="yukkalab"
      (click)="inLogo()"
    />
  </div>
  <div class="menu-above-rigt">
    <div class="abovel">
      <app-menu-search
        *ngIf="!routing.isMarketBoard() && !routing.isDueDiligence()"
      ></app-menu-search>
    </div>
    <div class="abovem" *ngIf="!routing.isDueDiligence()">
      <app-global-filters-bar></app-global-filters-bar>
    </div>
    <div class="abover" [class.mobile]="(screenSize$ | async)?.isMobile">
      <app-menu-options></app-menu-options>
      <app-menu-user-top></app-menu-user-top>
    </div>
  </div>
</div>
